import Cookies from 'js-cookie'

class CookieNotice {
  constructor () {
    this.$el = document.querySelector('.js-cookie-notice')
    if (!this.$el)
      return

    this.$close = this.$el.querySelectorAll('.js-cookie-notice-close')
    this.check()
  }

  check () {
    if (Cookies.get('shipCookieNotice') == undefined) {
      this.show()
    } else {
      this.$el.parentNode.removeChild(this.$el)
    }
  }

  show () {
    for (let i = 0; i < this.$close.length; i++) {
      this.$close[i].addEventListener('click', this.onCloseClick.bind(this))
    }

    this.$el.classList.remove('is-hidden')
  }

  hide () {
    this.$el.classList.add('is-hidden')
  }

  onCloseClick (event) {
    event.preventDefault()
    Cookies.set('shipCookieNotice', 1, { expires: 3650 })
    this.hide()
  }
}

export default new CookieNotice()
